/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Face_Card_ConfigureInputs */

const vi_face_card_configure = /** @type {(inputs: Face_Card_ConfigureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cấu hình nhận diện khuôn mặt`)
};

/**

* @param {Face_Card_ConfigureInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const face_card_configure = /** @type {((inputs?: Face_Card_ConfigureInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Face_Card_ConfigureInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_face_card_configure(inputs)
});